import React, { useState, useEffect } from "react";
import TableCompo from "../../Table/TableCompo";
import {
  Box,
  Typography,
  TextField,
  Button,
  Card,
  CardContent,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import Sidebar from "../../../Drawer/Sidebar";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllSipListRequest } from "../../../../redux/SipPlan/SipPlanSlice";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

const SipList = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useDispatch();
  const { allSipList, loading } = useSelector((state) => state.sipplan);
  const taxType = useSelector(
    (state) => state?.appConfig?.configData?.taxtype || "GST",
  );
  console.log("taxType", taxType);

  useEffect(() => {
    dispatch(fetchAllSipListRequest());
  }, [dispatch]);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const variable = (allSipList || []).map((item) => {
    const transaction = item?.transactions?.transactions ?? {};

    return {
      createdAt: new Date(item.createdAt).toLocaleDateString(),
      name: `${item?.customerDetails?.firstName ?? ""} ${item?.customerDetails?.lastName ?? "N.A"}`,
      phone: item?.customerDetails?.phone ?? "N.A",
      address: item?.customerDetails?.address?.[0]?.city ?? "N.A",
      metalPurity: `${item?.bullion?.metalName ?? ""} (${item?.bullion?.karat ?? "N.A"}K - ${item?.bullion?.purity ?? "N.A"})`,
      amount: item.installmentAmount ?? "N.A",
      months: item.noOfMonths ?? "N.A",
      status: item.status ?? "N.A",
      logindetails:
        item?.customerDetails?.logindetails?.currentLoginAt ?? "N.A",
      metalRate: transaction?.rate ?? "N.A",
      weight: transaction?.weight ?? "N.A",
      amounts:
        transaction?.rate && transaction?.weight
          ? transaction.rate * transaction.weight
          : "N.A",
      CGST: transaction?.total_tax ? transaction.total_tax / 2 : "N.A",
      SGST: transaction?.total_tax ? transaction.total_tax / 2 : "N.A",
      IGST: "N.A",
      TAX: transaction?.total_tax ? transaction.total_tax : "N.A",
      CESS: transaction?.cess ?? 0,
      total:
        transaction?.total_tax && transaction?.weight && transaction.rate
          ? transaction.total_tax + transaction.weight * transaction.rate
          : "N.A",
      paidInstallments: item.paidInstallments ?? "N.A",
      pending: Number(item.noOfMonths) - Number(item.paidInstallments),
      lastPaid: item.lastPaid ?? "N.A",
      Upcoming:
        item.status == "PENDING" || item.status == "CANCELED"
          ? item.Upcoming
          : "N.A",
    };
  });

  const columns = [
    { field: "id", headerName: "Id", hide: true },
    { field: "createdAt", headerName: "Created At" },
    { field: "", headerName: "Book Number" },
    { field: "name", headerName: "Name" },
    { field: "phone", headerName: "Phone" },
    { field: "address", headerName: "Address" },
    { field: "logindetails", headerName: "Last Login" },
    { field: "metalPurity", headerName: "Metal (Purity)" },
    { field: "amount", headerName: "Installment Amount" },
    { field: "metalRate", headerName: "Metal Rate" },
    { field: "weight", headerName: "Weight" },
    { field: "amounts", headerName: "Amount" },
    { field: "CGST", headerName: "CGST" },
    { field: "SGST", headerName: "SGST" },
    { field: "IGST", headerName: "IGST" },
    { field: "TAX", headerName: "TAX" },
    { field: "CESS", headerName: "CESS" },
    { field: "total", headerName: "Total" },
    { field: "months", headerName: "Months" },
    { field: "paidInstallments", headerName: "Paid" },
    { field: "pending", headerName: "Pending" },
    { field: "lastPaid", headerName: "Last Paid" },
    { field: "Upcoming", headerName: "Upcoming" },
    { field: "", headerName: "Plan Expires On" },
    {
      field: "status",
      headerName: "Status",
      render: (val) => {
        let color = "#6c757d";
        if (val === "COMPLETED") color = "green";
        else if (val === "PENDING") color = "orange";
        else if (val == "RUNNING") color = "orange";
        else if (val === "CANCELLED") color = "red";

        return (
          <span style={{ color, fontWeight: 600, textTransform: "capitalize" }}>
            {val?.toLowerCase()}
          </span>
        );
      },
    },

    {
      field: "Details",
      headerName: "View Details",
      render: (val, row) => (
        <button
          style={{
            backgroundColor: "#ffc107",
            color: "#000",
            border: "none",
            padding: "5px 10px",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          View
        </button>
      ),
    },
  ];

  const filteredColumns = React.useMemo(() => {
    if (taxType === "VAT") {
      return columns.filter(
        (col) => !["CGST", "SGST", "IGST"].includes(col.field),
      );
    }

    // GST
    return columns.filter((col) => !["TAX", "CESS"].includes(col.field));
  }, [taxType, columns]);

  return (
    <Box sx={{ width: "100%", height: "100vh", overflow: "auto" }}>
      <Box
        sx={{
          width: "1143px",
          mt: { xs: 10, md: 10 },
          background: "red",
          borderRadius: "16px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Box sx={{ alignItems: "center", mb: 2 }}>
          <Typography
            sx={{ fontSize: "24px", fontWeight: 700 }}
            fontFamily={"Aeonik"}
            p={2}
            mb={1}
          >
            Sip List
          </Typography>

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Box
              display="flex"
              flexDirection={isMobile ? "column" : "row"}
              gap={2}
              paddingInline={2}
            >
              <DatePicker
                label="Select Start Date"
                value={startDate}
                onChange={setStartDate}
                sx={{ minWidth: { xs: "210px", sm: "332px" } }}
                renderInput={(params) => <TextField size="small" {...params} />}
              />
              <DatePicker
                label="Select End Date"
                value={endDate}
                onChange={setEndDate}
                sx={{ minWidth: { xs: "210px", sm: "332px" } }}
                renderInput={(params) => (
                  <TextField size="small" {...params} fullWidth />
                )}
              />
              <Button
                variant="contained"
                fullWidth={isMobile}
                sx={{
                  backgroundColor: "#752ADA",
                  whiteSpace: "nowrap",
                  textTransform: "none",
                  px: 6,
                  fontSize: "16px",
                  mt: isMobile ? 1 : 0,
                }}
              >
                Get Details
              </Button>
            </Box>
          </LocalizationProvider>

          <CardContent
            sx={{
              height: "580px",
              width: "100%",
            }}
          >
            <TableCompo
              columns={filteredColumns}
              data={variable}
              totalCount={variable.length}
            />
          </CardContent>
        </Box>
      </Box>
    </Box>
  );
};

export default SipList;
